import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { elEnergyChartData, elEnergyChartOptions } from '../../chart-options';
import { BaseResultChartComponent } from '../base-result-chart-component.directive';

@Component({
  selector: 'psc-yearly-chart',
  templateUrl: './yearly-chart.component.html',
})
export class YearlyChartComponent extends BaseResultChartComponent implements OnInit {

  protected readonly elEnergyChartData = elEnergyChartData();
  protected readonly elEnergyChartOptions = elEnergyChartOptions();
  protected readonly elEnergyChartType: ChartType = 'line';


  override ngOnInit() {
    super.ngOnInit();
    this.subscribeToLabelTranslation('consumption', this.elEnergyChartData.datasets[0]);
    this.subscribeToLabelTranslation('production', this.elEnergyChartData.datasets[1]);


    this.subs.sink = this.resultChartsService.generateChartImageRequest.annualGraph.subscribe(
      () => {
        const hiddenChart = this.charts.get(1);

        hiddenChart?.chart?.canvas.toBlob(blob => {
          this.resultChartsService.chartImageGenerated.annualGraph.next(blob as Blob);
        }, 'image/png');

      },
    );
  }

  protected setChartData() {
    this.elEnergyChartData.datasets[0].data = this.solarCalculatorResult.monthlyResult.map(result => result.consumptionKWh);
    this.elEnergyChartData.datasets[1].data = this.solarCalculatorResult.monthlyResult.map(result => result.productionKWh);
  }
}
